import React, { Component } from "react";
import CouponApplyLogService from "../../services/couponapplylogservice";

// Audit -> Coupon Applies. Every discount code an admin applied to an already-billed
// (Performa) invoice via the "Apply Coupon" button, from lk_admin_invoice_discount_log.
// Self-contained .cal- CSS so it cannot clobber the rest of the portal.
const CSS = `
.cal-wrap{padding:18px 22px;font-family:inherit;color:#313030}
.cal-h{display:flex;align-items:baseline;gap:14px;flex-wrap:wrap;margin-bottom:4px}
.cal-h1{font-size:20px;font-weight:600;margin:0}
.cal-sub{font-size:13px;color:#6b6b6b;margin:0 0 16px}
.cal-bar{display:flex;gap:18px;flex-wrap:wrap;align-items:center;margin-bottom:16px}
.cal-seg{display:inline-flex;border:1px solid #e0dede;border-radius:8px;overflow:hidden}
.cal-seg button{border:0;background:#fff;padding:7px 14px;font-size:13px;cursor:pointer;color:#555}
.cal-seg button+button{border-left:1px solid #e0dede}
.cal-seg button.on{background:#ED0170;color:#fff}
.cal-count{font-size:12px;color:#8a8a8a}
.cal-tblwrap{overflow-x:auto}
.cal-tbl{width:100%;border-collapse:collapse;font-size:13px;min-width:860px}
.cal-tbl th{text-align:left;font-weight:600;color:#8a8a8a;font-size:11.5px;text-transform:uppercase;letter-spacing:.4px;padding:0 10px 7px 0;border-bottom:1px solid #eceaea;white-space:nowrap}
.cal-tbl td{padding:8px 10px 8px 0;border-bottom:1px solid #f5f4f4;vertical-align:top}
.cal-tbl td.n{text-align:right;font-variant-numeric:tabular-nums;white-space:nowrap}
.cal-code{display:inline-block;font-size:11.5px;font-weight:600;padding:1px 8px;border-radius:20px;background:#fdf0f6;color:#ED0170}
.cal-old{color:#9a9a9a;text-decoration:line-through;margin-right:6px}
.cal-new{color:#1e8e5a;font-weight:600}
.cal-sub2{font-size:11px;color:#9a9a9a}
.cal-empty{font-size:13px;color:#9a9a9a;padding:14px 0}
.cal-err{font-size:13px;color:#c0392b;padding:14px 0}
`;

const WINDOWS = [7, 30, 90];
const money = (v) => "₹" + Number(v == null ? 0 : v).toLocaleString("en-IN");

export default class CouponApplyLog extends Component {
  constructor(props) {
    super(props);
    this.service = new CouponApplyLogService();
    this.state = { days: 30, rows: [], loading: true, error: "" };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ loading: true, error: "" });
    const data = await this.service.getLog(this.state.days);
    if (data && (data.error || data.statusCode === 401)) {
      this.setState({ loading: false, error: data.error || data.message || "Could not load the log." });
      return;
    }
    const rows = Array.isArray(data) ? data.slice() : [];
    // Newest first (JSON_ARRAYAGG does not guarantee order).
    rows.sort((a, b) => String(b.AppliedOn || "").localeCompare(String(a.AppliedOn || "")));
    this.setState({ rows, loading: false });
  };

  pick = (days) => this.setState({ days }, this.load);

  render() {
    const { days, rows, loading, error } = this.state;
    return (
      <div className="cal-wrap">
        <style>{CSS}</style>
        <div className="cal-h">
          <h1 className="cal-h1">Coupon Applies</h1>
        </div>
        <p className="cal-sub">
          Discount codes applied to already-billed (unsettled) invoices via the Apply Coupon
          button. Every apply is logged here with the before/after total and who applied it.
        </p>

        <div className="cal-bar">
          <div className="cal-seg">
            {WINDOWS.map((w) => (
              <button key={w} className={days === w ? "on" : ""} onClick={() => this.pick(w)}>
                {w} days
              </button>
            ))}
          </div>
          {!loading && !error ? (
            <span className="cal-count">{rows.length} {rows.length === 1 ? "apply" : "applies"}</span>
          ) : null}
        </div>

        {loading ? (
          <div className="cal-empty">Loading...</div>
        ) : error ? (
          <div className="cal-err">{error}</div>
        ) : rows.length === 0 ? (
          <div className="cal-empty">No coupons have been applied in this window.</div>
        ) : (
          <div className="cal-tblwrap">
            <table className="cal-tbl">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Store</th>
                  <th>Invoice</th>
                  <th>Customer</th>
                  <th>Code</th>
                  <th className="n">Old &rarr; New</th>
                  <th className="n">Discount</th>
                  <th>Applied by</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.Id}>
                    <td className="n">{r.AppliedOn}</td>
                    <td className="n">{r.StoreID}</td>
                    <td>
                      {r.InvoiceNumber || r.InvoiceID}
                      <div className="cal-sub2">{r.SplitOrderNumber}</div>
                    </td>
                    <td>
                      {r.Customer || "-"}
                      <div className="cal-sub2">{r.Mobile}</div>
                    </td>
                    <td>
                      <span className="cal-code">{r.DiscountCode}</span>
                    </td>
                    <td className="n">
                      <span className="cal-old">{money(r.OldTotal)}</span>
                      <span className="cal-new">{money(r.NewTotal)}</span>
                    </td>
                    <td className="n">{money(r.DiscountAmount)}</td>
                    <td>
                      {r.AppliedByName || "-"}
                      <div className="cal-sub2">UID {r.AppliedBy}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}
